export default __webpack_public_path__ + "/dist/images/9552332.edcc95af006749ec54aaa44555658824.png";